import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import Modal, { IModalChildProps } from '../../common/modal';

const AddToCartModal = ({ onAccept, onClose }: IModalChildProps) => {
    const intl = useIntl();
    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({ id: 'Close' })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title">
                        <FormattedMessage id="Items_that_are_currently_in_yo" />
                    </h4>
                </div>
                <div className="modal-body">
                    <FormattedMessage id="Patient_orders_must_be_separate_continue" />
                </div>
                <div className="modal-footer">
                    <button className="btn btn-info" onClick={onAccept}>
                        <FormattedMessage id="Continue" />
                    </button>
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Cancel" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default AddToCartModal;
